import { render, staticRenderFns } from "./NotificationsDropDownMenu.vue?vue&type=template&id=666e088c&scoped=true&"
import script from "./NotificationsDropDownMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropDownMenu.vue?vue&type=style&index=0&id=666e088c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e088c",
  null
  
)

export default component.exports